import { defineComponent as _defineComponent } from 'vue'
import { computed, useRoute, useStore } from '@nuxtjs/composition-api'
import pageNavigation from '~/composeables/pageNavigation/pageNavigation'
import MonitoringQuickStats from '~/components/feature/MonitoringQuickStats/MonitoringQuickStats.vue'
import SalesLabel from '~/components/base/SalesLabel/SalesLabel/SalesLabel.vue'
import upsellContentScreen from '~/composeables/upsellContentScreen/upsellContentScreen'
import { cleanUpPath } from '~/utils/pathStore'
import Skeleton from '~/components/pure/Skeleton/Skeleton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  setup(__props) {

const store = useStore()

const { subNavigation, activeNav } = pageNavigation()
const { triggerUpsellContent } = upsellContentScreen()
const getUserPlan = computed(() => store.getters['access/getUserPlan'])
const getIsReady = computed(() => store.getters['whitelabel/getIsReady'])

const aTriggerUpsellContent = async (contentId: string) => {
  await triggerUpsellContent(contentId)
}

const route = useRoute()

const isPageHeaderDisabled = computed(() => {
  cleanUpPath(route.value.fullPath)
  return (/^\/user(\/license)?(\/)?|^\/blocklist(\/.*)?$/.test(route.value.path))
})


return { __sfc: true,store, subNavigation, activeNav, triggerUpsellContent, getUserPlan, getIsReady, aTriggerUpsellContent, route, isPageHeaderDisabled, SalesLabel, Skeleton }
}

})